<div class="database-container">

  <ng-container>
    <section class="project-entities-titlebar">
      <div class="project-entities-titlebar-left">
        <h3><i class="fa-regular fa-database"></i> Database</h3>
        <p>
          Explore your database. You can view, edit, and manage data in your data tables.
        </p>
      </div>
      <div class="project-entities-titlebar-right">

                <button nz-button
                        nz-tooltip
                        [nzTooltipTitle]="'Manage Data Table Schema'"
                        nzType="default"
                        nzSize="small"
                        class="db-diagram-button"
                        (click)="onUpdateDataTableSchemaButtonClicked()">
                  <i class="fa-regular fa-gear"></i>&nbsp;Manage Data Table Schema
                </button>

        <button *ngIf="activeEntityConfig"
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Display data tables'"
                nzType="default"
                nzSize="small"
                class="tables-home-button"
                (click)="onDbHomeButtonClicked()">
          <i class="fa-regular fa-table"></i>&nbsp;All Tables
        </button>

        <button nz-button
                nz-tooltip
                [nzTooltipTitle]="'Display database diagram'"
                nzType="default"
                nzSize="small"
                class="db-diagram-button"
                (click)="onDbDiagramButtonClicked()">
          <i class="fa-regular fa-diagram-project"></i>&nbsp;DB Diagram
        </button>
      </div>

    </section>
    <rappider-ai-crud-view [activeEntityConfig]="activeEntityConfig"
                           [entityConfigs]="entityConfigs"
                           [entityData]="entityData"
                           [addListGridItemDefaultActions]="false"
                           (entitySelected)="onEntitySelected($event)"
                           (joyrideDoneButtonClick)="onJoyrideDoneButtonClick()"
                           (actionCardClicked)="onActionCardClicked($event)"
                           (entityItemSelected)="onEntityItemSelected($event)"
                           (gridBuilderConfigSaved)="onGridBuilderConfigSaved($event)"
                           (listGridVisibilityColumnsChanged)="onListGridVisibilityColumnsChanged($event)"></rappider-ai-crud-view>
  </ng-container>

</div>


<rappider-ai-input-modal [aiDialogId]="createNewModelWithAIDialogId"
                         (textSubmitted)="createProjectModelWithAi($event)"></rappider-ai-input-modal>
